import { render } from "./index.vue?vue&type=template&id=87070eca"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "../DistrictsView/index.styl?vue&type=style&index=0&lang=stylus&module=true"
cssModules["$style"] = style0

import exportComponent from "/builds/pages/gmap/node_modules/.pnpm/vue-loader@16.8.3_vue@3.3.11_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__